"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustryNodeSchema = exports.IndustrySchema = exports.IndustryI18nSchema = void 0;
/* eslint-disable perfectionist/sort-objects */
const zod_1 = require("zod");
const __1 = require("../..");
exports.IndustryI18nSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    industryId: zod_1.z.string(),
    locale: zod_1.z.string(),
    name: zod_1.z.string(),
});
exports.IndustrySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    parentId: zod_1.z.string().nullable(),
    code: zod_1.z.string(),
    order: zod_1.z.number().int().nullable(),
});
exports.IndustryNodeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    code: zod_1.z.string(),
    order: zod_1.z.number().int().nullable(),
    localized: __1.LocalizedFieldSchema,
    children: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        code: zod_1.z.string(),
        order: zod_1.z.number().int().nullable(),
        localized: __1.LocalizedFieldSchema,
    }),
});
